<template>
  <div>
    <div class="section">
      <span class="ws-eyebrow">Help mee</span>
      <h1 class="ws-h1 mt-3">Steun ons</h1>
      <p class="ws-lead ws-lead--lg steun-sub">
        Er zijn meerdere mogelijkheden waarop u ons kunt steunen. Neem
        vrijblijvend contact met ons op wanneer u vragen heeft of wilt steunen.
      </p>

      <div class="mogelijkheden ws-stagger" v-reveal>
        <div
          class="ws-card ws-card--hover support-card ws-reveal"
          v-for="(item, i) in options"
          :key="i"
          :style="{ '--i': i }"
        >
          <span class="support-icon">
            <v-img :src="require('@/assets/sun.svg')" alt="" contain></v-img>
          </span>
          <h2 class="support-title">{{ item.title }}</h2>
          <p class="ws-lead support-text">{{ item.text }}</p>

          <DoneerKnoppen v-if="item.donate">
            <template #activator="{ props }">
              <button v-bind="props" class="ws-btn ws-btn--primary support-cta">
                <span style="font-size: 17px">♥</span> Doneer
              </button>
            </template>
          </DoneerKnoppen>
          <button
            v-else
            class="ws-btn ws-btn--ghost support-cta"
            @click="$router.push('/contact')"
          >
            Neem contact op →
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
import DoneerKnoppen from "@/components/DoneerKnoppen.vue";

export default {
  components: {
    DoneerKnoppen,
  },
  setup() {
    useMeta({
      title: "Steun ons",
    });
  },
  data() {
    return {
      options: [
        {
          title: "Donateur worden",
          text: "Met donateurschap steunt u de stichting met een financiele bijdrage. Hiermee kunnen we de vakanties voor de gezinnen zo kosteloos als mogelijk maken.",
          donate: true,
        },
        {
          title: "Uw huis ter beschikking stellen",
          text: "Door uw (vakantie)huis ter beschikking te stellen, kunnen gezinnen met zieke kinderen hier gebruik van maken als plek waar ze een nieuwe start kunnen beleven.",
          donate: false,
        },
        {
          title: "Partner worden",
          text: "Als partner kunt u ons op elke manier steunen, door bijv. bij te dragen aan zaken die elke stichting nodig heeft. Denk aan marketing, administratief, juridisch, IT en meer.",
          donate: false,
        },
        {
          title: "Vrijwilliger worden",
          text: "Wilt u persoonlijk meehelpen met de stichting? Neem dan contact met ons op om in gesprek te gaan over de mogelijkheden.",
          donate: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.steun-sub {
  max-width: 50%;
  margin: 16px 0 5vh;
}

.mogelijkheden {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}

.support-icon {
  width: 56px;
  height: 56px;
  border-radius: 15px;
  background: radial-gradient(circle at 50% 42%, #fbb040, #ea6b26);
  box-shadow: 0 6px 16px -4px rgba(234, 107, 38, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  margin-bottom: 18px;
}

.support-title {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 22px;
  color: #241b12;
  margin-bottom: 11px;
}
.support-text {
  font-size: 15.5px;
  flex: 1;
}
.support-cta {
  margin-top: 22px;
  align-self: flex-start;
}

@media screen and (max-width: 900px) {
  .mogelijkheden {
    grid-template-columns: 1fr;
  }
  .steun-sub {
    max-width: 100%;
  }
}
</style>
